import { render, staticRenderFns } from "./ModalTelefoneAdicionar.vue?vue&type=template&id=0b176ba2&scoped=true"
import script from "./ModalTelefoneAdicionar.vue?vue&type=script&lang=js"
export * from "./ModalTelefoneAdicionar.vue?vue&type=script&lang=js"
import style0 from "./ModalTelefoneAdicionar.vue?vue&type=style&index=0&id=0b176ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b176ba2",
  null
  
)

export default component.exports